<template>
  <v-row class="align-center justify-center pa-2">

    <v-btn
    v-if="!compact && pagination.pages > 1"
    text
    :disabled="page <= 0"
    @click="$emit('goToFirstPage')"
    class="mr-2"
    >
      1
    </v-btn>

    <v-btn
    text
    :disabled="page <= 0"
    @click="$emit('goToPreviousPage')"
    class="mr-2"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <c-input :value.sync="localPage" style="max-width: 3em;">
    </c-input>

    <span v-if="compact" class="overline">
      / {{ pagination.pages || 1 }}
    </span>

    <v-btn
    :disabled="page >= pagination.pages - 1"
    text
    @click="$emit('goToNextPage')"
    class="ml-2 mr-2"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>

    <v-btn
    v-if="!compact && pagination.pages > 1"
    text
    :disabled="!(page < (pagination.pages - 1))"
    @click="$emit('goToLastPage')"
    class="mr-2"
    >
      {{ pagination.pages || 1 }}
    </v-btn>

    <v-spacer></v-spacer>

    <template>
      <items-per-page :rowsPerPage.sync="filters.rowsPerPage" class="mr-2"></items-per-page>
    </template>

  </v-row>
</template>

<script>
import CSListItemsPerPage from './C-SListItemsPerPage'

export default {
  props: {
    page: null,
    pagination: {},
    filters: {},
    // Settings
    compact: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'items-per-page': CSListItemsPerPage
  },
  computed: {
    localPage: {
      get () {
        return this.page + 1
      },
      set (nv) {
        this.$emit('updatePageNumber', nv - 1)
      }
    }
  }
}
</script>